<template>
  <form class="basicForm__form" v-on:submit.prevent="onSubmit">
    <h3 class="basicForm__title">Zaujala vás tato pozice?</h3>
    <p class="basicForm__desc">Nechte nám váš kontakt a ozveme se vám.</p>

    <div class="basicForm__row basicForm__item">
      <label for="name" class="basicForm__label">Jméno</label>
      <input id="name" class="basicForm__input" size="31" v-model="name">
    </div>
    <div class="basicForm__row basicForm__item">
      <label for="surname" class="basicForm__label">Příjmení</label>
      <input id="surname" class="basicForm__input" size="31" v-model="surname">
    </div>
    <div class="basicForm__row basicForm__item">
      <label for="email" class="basicForm__label">E-mail</label>
      <input type="email" id="email" class="basicForm__input" size="24" v-model="email">
    </div>
    <div class="basicForm__row basicForm__item">
      <label for="phone" class="basicForm__label">Telefon</label>
      <input type="tel" id="phone" class="basicForm__input" size="24" v-model="phone"/>
    </div>
    <career-file-upload section="cv" title="Přiložit CV" :user-file-name="inputFileName('cv')" @onUpload="onUpload"/>
    <career-file-upload section="attachment" title="Přiložit přílohu" :user-file-name="inputFileName('attachment')"
                        @onUpload="onUpload"/>
    <div class="basicForm__row basicForm__item">
      <label class="basicForm__label">Průvodní dopis</label>
      <textarea class="basicForm__input" v-model="coverLetter"></textarea>
    </div>
    <div class="basicForm__row basicForm__item">
      <label class="checkbox">
        <input type="checkbox" id="agree" class="checkbox-native" name="gdpr" v-model="gdpr">
        <span class="checkbox-control"></span>
        <span class="checkbox-label">
                    <span class="text--grey">
                        Odesláním Vašich osobních údajů a reakcí na náš inzerát udělujete svůj souhlas k tomu, abychom zpracovávali Vaše osobní údaje, které jste nám poskytl(a). Svůj souhlas udělujete společnosti Saint-Gobain Construction Products CZ a.s. se sídlem Smrčkova 2485/4, 180 00 Praha-Libeň, IČO 25029673 a jejím koncernovým společnostem Saint-Gobain v České a Slovenské republice. Tyto společnosti, jakožto správci, budou zpracovávat Vámi poskytnuté (či z veřejných zdrojů získané) osobní údaje, a to v souladu s Nařízením Evropského Parlamentu a Rady EU o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů 2016/679 po dobu výběrového řízení, maximálně 6 měsíců od podání Vaší žádosti.
                        <a href="/souhlas-se-zpracovanim-osobnich-udaju" class="link--default" target="_blank"
                           title="Více informací">Více informací</a>.
                    </span>
                </span>
      </label>
    </div>
    <div class="basicForm__row basicForm__item">
      <label class="checkbox">
        <input type="checkbox" id="offers" class="checkbox-native" name="offers" v-model="offers">
        <span class="checkbox-control"></span>
        <span class="checkbox-label">
                    <span class="text--grey">
                        Ano, chci, aby mi dali vědět ze Saint-Gobain, když pro mě budou mít i jinou vhodnou pozici
                        <a href="/souhlas-se-zasilanim-obdobnych-pracovnich-pozic" class="link--default" target="_blank"
                           title="Více">Více</a>.
                    </span>
                </span>
      </label>
    </div>
    <div class="basicForm__row basicForm__item">
      <button type="submit" class="button view-primary-light form__button">
        {{processing ? 'Odesílám...' : 'Mám zájem o tuto pozici'}}
      </button>
    </div>
    <ul v-if="errors.length">
      <li v-for="error in errors">{{error.message}}</li>
    </ul>
    <div v-if="success">
      Formulář byl úspěšně odeslán
    </div>
  </form>
</template>

<script>
    import remove from 'lodash/remove';
    import find from 'lodash/find';
    import isUndefined from 'lodash/isUndefined';
    import {sendCareerForm} from './api/career';
    import {pushGTM} from '../../helpers/gtm';
    import filter from 'lodash/filter';
    import CareerFileUpload from "./FileUpload";

    function initialState() {
        const h1 = document.querySelector('h1');
        return {
            processing:  false,
            name:        '',
            surname:     '',
            phone:       '',
            email:       '',
            letter:      '',
            coverLetter: '',
            gdpr:        false,
            offers:      false,
            errors:      [],
            success:     false,
            files:       [],
            jobName:     h1 ? h1.innerText : null,
        }
    }

    export default {
        name:       'CareerForm',
        components: { CareerFileUpload },
        data() {
            return initialState()
        },
        methods:    {
            onSubmit() {
                if (false == this.validate('input')) {
                    this.processing = true;
                    sendCareerForm(this.prepareData())
                    .then(() => {
                        this.reset();
                        this.successForm();
                    })
                    .catch(() => this.errors.push({
                        message: 'Formulář se nepodařilo odeslat, zkuste to znovu',
                        type:    'request'
                    }))
                    .finally(() => this.processing = false)
                }
            },
            validate(type) {
                this.errors = [];
                if (this.name.length === 0 && this.surname.length === 0) {
                    this.errors.push({ message: 'Zadejte jméno nebo přijmení', type: 'input' });
                }
                if (this.email.length === 0 && this.phone.length === 0) {
                    this.errors.push({ message: 'Zadejte e-mail nebo telefon', type: 'input' });
                }
                if (this.email.length === 0 && this.letter.length === 0) {
                    this.errors.push({ message: 'Vyplnte průvodní dopis', type: 'input' });
                }
                if (this.gdpr === false) {
                    this.errors.push({ message: 'Musíte souhlasit se zpracováním osobních údajů', type: 'input' });
                }
                if (this.files.length === 0) {
                    this.errors.push({ message: 'Nahrajte své CV', type: 'input' });
                } else if (isUndefined(find(this.files, { type: 'cv' }))) {
                    this.errors.push({ message: 'Nahrajte své CV', type: 'input' });
                }

                return filter(this.errors, error => error.type === type).length;
            },
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this));
            },
            successForm() {
                this.success = true;
                setTimeout(() => this.success = false, 10000);
                pushGTM('HR campaign', 'Application form sent');
            },
            prepareData() {
                return {
                    name:        this.name,
                    surname:     this.surname,
                    email:       this.email,
                    phone:       this.phone,
                    offers:      this.offers,
                    gdpr:        this.gdpr,
                    files:       this.files,
                    coverLetter: this.coverLetter,
                    job:         this.$route.params.slug,
                    jobName:     this.jobName,
                };
            },
            onUpload(data) {
                let files = this.files;
                files = remove(files, (file) => file !== data.type);
                files.push(data);

                this.files = files;
            },
            inputFileName(type) {
                const file = find(this.files, (file) => file.type === type);
                if (!isUndefined(file)) {
                    return file.userFileName;
                }
                return null;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/career/Form.vue